var _defs, _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4788",
    "data-name": "Group 4788",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 220.672,
    height: 50.713,
    viewBox: "0 0 220.672 50.713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2826",
    "data-name": "Rectangle 2826",
    width: 220.672,
    height: 50.713,
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M192.264,39.8V19.262l-7.221,5.228V38.575Z",
    transform: "translate(-127.15 -13.236)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M211.817,40.163V20.293L210.4,19.262v20.66Z",
    transform: "translate(-144.576 -13.236)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M218.411,43.644V24.8L217,23.818V43.4Z",
    transform: "translate(-149.107 -16.367)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4787",
    "data-name": "Group 4787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4786",
    "data-name": "Group 4786",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M237.918,67.7a1.657,1.657,0,0,1,.9.466l2.32,2.32V60.6l-5.285-3.391V67.35Z",
    transform: "translate(-162.064 -39.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    d: "M231.305,50.059V33.033l-1.413-.876V49.819Z",
    transform: "translate(-157.968 -22.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    d: "M224.733,46.858V28.936l-1.413-.929V46.618Z",
    transform: "translate(-153.451 -19.245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M82.689,66.671V56.359l-4.776-3.314V65.839Z",
    transform: "translate(-53.537 -36.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M161.091,26.632l-2.427-1.283V23.117l3.683,2.023a1.664,1.664,0,0,1,1.029-.155l.742.126V24.05L158.748,21.2V18.934l5.369,3.024V19.839l-5.426-2.883V14.639l5.426,2.968V15.6l-5.454-2.939V10.485l5.454,2.953V11.333l-5.482-2.939V6.132l5.482,3.052v-5.1L156.544,0V32.946c1.15-1.58,3.483-4.795,4.547-6.314",
    transform: "translate(-107.567)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    d: "M64.716,65.673V53.046L60.1,56.628v8.241Z",
    transform: "translate(-41.294 -36.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    d: "M91.442,44.841l2.614.455V21l-4.988,3.971v7.093l2.374,1.357Z",
    transform: "translate(-61.202 -14.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    "data-name": "Path 3875",
    d: "M135.415,33.4a1.647,1.647,0,0,1,.219.056V0l-7.588,4.282v27.84Z",
    transform: "translate(-87.985 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    "data-name": "Path 3876",
    d: "M113.147,46.309V24.774L108.4,21v24.48Z",
    transform: "translate(-74.485 -14.431)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    "data-name": "Path 3877",
    d: "M2.08,120.455l16.048-17.686-.839-1.273L0,120.455Z",
    transform: "translate(0 -69.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3878",
    "data-name": "Path 3878",
    d: "M55.466,95.447,71.42,116.3l14.123-15.584Z",
    transform: "translate(-38.113 -65.585)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3879",
    "data-name": "Path 3879",
    d: "M115.8,114.407,134.046,94.12,132.6,92.695l-19.435,21.712Z",
    transform: "translate(-77.76 -63.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3880",
    "data-name": "Path 3880",
    d: "M218.393,109.2,207.636,98.527V94.193l-4.416-.74V97.8l-1.653-1.653V92.561l-4.035-4.035-20.045-3.4L199.618,109.2Z",
    transform: "translate(-121.958 -58.491)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3881",
    "data-name": "Path 3881",
    d: "M26.577,110.506v-7.08l3.769.93v2.039Z",
    transform: "translate(-18.262 -71.067)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2816",
    "data-name": "Rectangle 2816",
    width: 1.898,
    height: 1.903,
    transform: "translate(19.224 39.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2817",
    "data-name": "Rectangle 2817",
    width: 1.865,
    height: 1.903,
    transform: "translate(16.88 39.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2818",
    "data-name": "Rectangle 2818",
    width: 1.898,
    height: 1.903,
    transform: "translate(19.224 42.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2819",
    "data-name": "Rectangle 2819",
    width: 1.865,
    height: 1.903,
    transform: "translate(16.88 42.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2820",
    "data-name": "Rectangle 2820",
    width: 2.122,
    height: 2.128,
    transform: "translate(57.491 38.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2821",
    "data-name": "Rectangle 2821",
    width: 2.085,
    height: 2.128,
    transform: "translate(54.871 38.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2822",
    "data-name": "Rectangle 2822",
    width: 2.122,
    height: 2.128,
    transform: "translate(57.491 41.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2823",
    "data-name": "Rectangle 2823",
    width: 2.085,
    height: 2.128,
    transform: "translate(54.871 41.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3882",
    "data-name": "Path 3882",
    d: "M318.328,74.028V55.048h4.105V70.509h9.756v3.519Z",
    transform: "translate(-218.735 -37.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2824",
    "data-name": "Rectangle 2824",
    width: 4.185,
    height: 19.033,
    transform: "translate(115.801 17.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3883",
    "data-name": "Path 3883",
    d: "M394.89,67.69c.426,2.506,2.666,2.852,4.212,2.852,1.466,0,3.705-.427,3.705-2.372,0-4.052-11.329-1.439-11.329-8.557,0-3.918,3.679-5.758,7.117-5.758,3.972,0,7.624,1.732,7.624,6.131l-4.052-.586c-.506-2.213-2.452-2.293-3.758-2.293-1.333,0-2.879.56-2.879,2.159,0,1.413.906,1.733,5.677,2.879,1.413.347,5.651,1.226,5.651,5.545,0,3.492-2.719,6.1-7.917,6.1-4.265,0-8.1-2.079-8.1-6.77Z",
    transform: "translate(-268.559 -37.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3884",
    "data-name": "Path 3884",
    d: "M452.1,58.882h-6.051V55.39h16.233v3.518h-6V74.4H452.1Z",
    transform: "translate(-306.499 -38.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2825",
    "data-name": "Rectangle 2825",
    width: 4.185,
    height: 19.033,
    transform: "translate(158.187 17.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    "data-name": "Path 3885",
    d: "M532.61,61.078V74.246h-3.652V55.133h4.8l8.5,11.889V55.133H545.8V74.246H542.26Z",
    transform: "translate(-363.467 -37.884)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3886",
    "data-name": "Path 3886",
    d: "M606.821,68.777A9.844,9.844,0,1,1,598.184,54.2a9.984,9.984,0,0,1,8.61,5.012c-1.68.853-1.813.933-3.679,1.866a5.612,5.612,0,0,0-4.932-2.8,5.758,5.758,0,0,0,0,11.516,5.409,5.409,0,0,0,5.038-2.879H602.8c-.853,0-2.8.027-3.865.027a3.076,3.076,0,0,1-.747-.027V63.393c2.692,0,6.451.027,9.73.027,0,.56-.107,4.078-1.093,5.358",
    transform: "translate(-404.276 -37.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3887",
    "data-name": "Path 3887",
    d: "M658.178,67.69c.426,2.506,2.666,2.852,4.212,2.852,1.466,0,3.705-.427,3.705-2.372,0-4.052-11.329-1.439-11.329-8.557,0-3.918,3.679-5.758,7.117-5.758,3.972,0,7.624,1.732,7.624,6.131l-4.052-.586c-.506-2.213-2.452-2.293-3.758-2.293-1.333,0-2.879.56-2.879,2.159,0,1.413.906,1.733,5.678,2.879,1.413.347,5.651,1.226,5.651,5.545,0,3.492-2.719,6.1-7.917,6.1-4.265,0-8.1-2.079-8.1-6.77Z",
    transform: "translate(-449.474 -37.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3888",
    "data-name": "Path 3888",
    d: "M420.363,128.548v5.583h-1.548v-8.1h2.035l3.6,5.04v-5.04h1.5v8.1h-1.5Z",
    transform: "translate(-287.783 -86.598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3889",
    "data-name": "Path 3889",
    d: "M454.372,130.874v1.718h4.554v1.492h-6.272v-8.092h5.888v1.491h-4.17v1.82h3.684v1.571Z",
    transform: "translate(-311.036 -86.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3890",
    "data-name": "Path 3890",
    d: "M481.473,134.193l3.661-8.058h1.785l3.605,8.058h-1.718l-.791-1.786h-4.08l-.848,1.786Zm4.577-6.544-1.356,3.119h2.678l-1.311-3.119Z",
    transform: "translate(-330.838 -86.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3891",
    "data-name": "Path 3891",
    d: "M524.9,131.186l2.26,3h-2.17l-2.034-2.9h-.87v2.9H520.3V126.1h3.639a2.5,2.5,0,0,1,2.814,2.588,2.417,2.417,0,0,1-1.921,2.5Zm-2.814-3.707v2.43h1.379c.848,0,1.548-.192,1.548-1.22,0-1.051-.7-1.209-1.548-1.209Z",
    transform: "translate(-357.515 -86.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    "data-name": "Path 3892",
    d: "M553.592,126.1h3.8c1.537,0,2.577.5,2.577,2a1.728,1.728,0,0,1-1.1,1.684,1.958,1.958,0,0,1,1.48,2.046c0,1.639-1.39,2.34-2.848,2.34h-3.911Zm1.775,3.266h1.8c.633,0,1.085-.283,1.085-.961,0-.757-.588-.926-1.22-.926h-1.661Zm0,3.424h1.9c.689,0,1.311-.226,1.311-1.062s-.509-1.153-1.277-1.153h-1.932Z",
    transform: "translate(-380.394 -86.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3893",
    "data-name": "Path 3893",
    d: "M586.4,131.027l-2.973-4.927h2l1.887,3.187,1.876-3.187h1.978l-2.995,4.972v3.1H586.4Z",
    transform: "translate(-400.891 -86.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3894",
    "data-name": "Path 3894",
    d: "M346.643,135.321c-16.426.583-28.325,1.375-28.325,1.375s11.9.792,28.325,1.375Z",
    transform: "translate(-218.728 -92.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    d: "M614.71,135.321c16.426.583,28.325,1.375,28.325,1.375s-11.9.792-28.325,1.375Z",
    transform: "translate(-422.39 -92.984)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e09c1f3ad507690256cbd908345aac2c.svg";
export { ForwardRef as ReactComponent };